import axios from '../utils/axios';

export default function fetchAllJobComments(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/comment/all-comments`, { params } )
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
